/* ============================================================
   PSM hero — best-seller hydration.
   Pulls the top-selling products (sold_90d) from the Typesense
   engine and fills:
     - the "Popular:" search chips  (top sellers' SKUs)
     - the featured product card     (random pick from the top 30,
       in stock, >= $5)
     - the two mini product cards    (two more random top sellers)
   The server-rendered products are the first-paint fallback; this
   swaps them on load.
   ============================================================ */
(function () {
  "use strict";

  var hero = document.querySelector("[data-psm-hero]");
  if (!hero) return;
  var host = hero.dataset.host, key = hero.dataset.key, index = hero.dataset.index;
  if (!host || !key || !index) return;

  var CHECK_SVG = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="m5 13 4 4L19 7"/></svg>';

  function money(n) { return "$" + Number(n).toFixed(2); }
  function img(url, w) { return url ? url + (url.indexOf("?") >= 0 ? "&" : "?") + "width=" + w : ""; }
  function sku(d) { return (d.skus && d.skus[0]) || d.title || ""; }

  // Replace the "N+" product count in the live-inventory kicker with the real
  // catalog size from the search index, rounded UP to the nearest 1,000.
  function updateKicker(total) {
    total = Number(total);
    if (!total || !isFinite(total)) return;
    var label = (Math.ceil(total / 1000) * 1000).toLocaleString("en-US") + "+";
    var el = hero.querySelector(".hero-kicker");
    if (el) {
      [].forEach.call(el.childNodes, function (n) {
        if (n.nodeType === 3 && /\d[\d,]*\+/.test(n.nodeValue)) {
          n.nodeValue = n.nodeValue.replace(/\d[\d,]*\+/, label);
        }
      });
    }
    // Keep the stats-row "SKUs ready to ship" figure in sync with the real catalog
    // size (e.g. the psm-stats section), rounded up to the nearest 1,000.
    document.querySelectorAll("[data-psm-catalog-count]").forEach(function (b) {
      b.innerHTML = label.replace("+", "") + "<em>+</em>";
    });
  }

  var search = {
    collection: index,
    q: "*",
    query_by: "title",
    filter_by: "in_stock:=true && price_min:>=5",
    sort_by: "sold_90d:desc",
    per_page: 30,
    include_fields: "title,handle,url,skus,price_min,image,first_qty,subtitle",
  };

  fetch(host + "/multi_search", {
    method: "POST",
    headers: { "Content-Type": "application/json", "X-TYPESENSE-API-KEY": key },
    body: JSON.stringify({ searches: [search] }),
  })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var res = (data.results || [])[0] || {};
      updateKicker(res.out_of); // live catalog size, rounded up to the nearest 1,000
      var hits = res.hits || [];
      var docs = hits.map(function (h) { return h.document; });
      if (!docs.length) return;

      fillChips(docs);

      // The feature + mini cards (.hero-stage-v2) are display:none below 640px,
      // so skip hydrating them on mobile — no image fetch, no wasted work. The
      // Popular chips and kicker count above stay visible and were already set.
      if (window.matchMedia("(max-width: 640px)").matches) return;

      // random, non-repeating picks from the top 30
      var pool = docs.slice();
      function take() {
        if (!pool.length) return null;
        return pool.splice(Math.floor(Math.random() * pool.length), 1)[0];
      }
      fillFeature(take());
      fillMini(hero.querySelector(".hs-mini-1"), take());
      fillMini(hero.querySelector(".hs-mini-2"), take());
    })
    .catch(function (e) { console.error("[psm-hero]", e); });

  function fillChips(docs) {
    var quick = hero.querySelector(".hero-quick");
    if (!quick) return;
    [].slice.call(quick.querySelectorAll("a")).forEach(function (a) { a.remove(); });
    docs.slice(0, 5).forEach(function (d) {
      var s = sku(d);
      var a = document.createElement("a");
      a.href = "/search?q=" + encodeURIComponent(s);
      a.textContent = s;
      quick.appendChild(a);
    });
  }

  // one randomly-chosen feature from the product subtitle (comma/·/|/;-split)
  function randomFeature(d) {
    var raw = (d.subtitle || "").replace(/[·|;]/g, ",");
    var parts = raw.split(",").map(function (s) { return s.trim(); }).filter(Boolean);
    if (!parts.length) return "";
    var f = parts[Math.floor(Math.random() * parts.length)];
    // capitalise the first letter for the chip
    return f.charAt(0).toUpperCase() + f.slice(1);
  }

  function fillFeature(d) {
    if (!d || !d.image) return; // keep the consistent server-rendered fallback if no image
    var a = hero.querySelector(".hs-feature");
    if (!a) return;
    a.href = d.url;
    var im = a.querySelector("img");
    if (im && d.image) { im.src = img(d.image, 480); im.alt = d.title; }
    var s = a.querySelector(".hc-sku"); if (s) s.textContent = sku(d);
    var t = a.querySelector(".hs-title"); if (t) t.textContent = d.title;
    var pr = a.querySelector(".hs-price"); if (pr) pr.textContent = money(d.price_min);
    var st = a.querySelector(".hc-stock");
    if (st) {
      if (d.first_qty > 0) {
        st.innerHTML = '<span class="stock-dot"></span>' + d.first_qty + " in stock";
        st.style.display = "";
      } else { st.style.display = "none"; }
    }
    // single floating chip: a randomly-chosen subtitle feature (the 120W /
    // 12V chips were removed per design)
    var feat = randomFeature(d);
    var c3 = a.querySelector(".hs-chip-3");
    if (c3) {
      if (feat) {
        c3.innerHTML = CHECK_SVG + ' <span class="hs-chip-3-txt">' + esc(feat) + "</span>";
        c3.style.display = "";
      } else { c3.style.display = "none"; }
    }
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function fillMini(a, d) {
    if (!a || !d) return;
    a.href = d.url;
    var im = a.querySelector("img");
    if (im && d.image) { im.src = img(d.image, 112); im.alt = d.title; }
    var s = a.querySelector(".hc-sku"); if (s) s.textContent = sku(d);
    var pr = a.querySelector(".hs-mini-price"); if (pr) pr.textContent = money(d.price_min);
  }
})();
